<template>
    <div>
        <b-modal
            id="createTeacher"
            title="Adicionar Professor"
            hide-footer>
            <b-overlay :show="loading" rounded="sm">
                <b-form @submit="submit" @submit.stop.prevent>

                    <!-- Field -->
                    <b-form-group
                        label="Nome">
                        <!-- Input -->
                        <b-form-input
                            v-model="form.name"
                            :state="hasErrors('name', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="name" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Email">
                        <!-- Input -->
                        <b-form-input
                            v-model="form.email"
                            :state="hasErrors('email', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="email" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Telefone">
                        <!-- Input -->
                        <b-form-input
                            maxlength="11"
                            v-model="form.phone"
                            :state="hasErrors('phone', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="phone" />
                    </b-form-group>
                
                    <!-- Field -->
                    <b-form-group
                        label="Senha Padrão" description="">

                        <!-- Input -->
                        <b-form-input
                            v-model="form.password"
                            :state="hasErrors('password', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="password" />
                    </b-form-group>

                    <!-- Submit -->
                    <b-button type="submit" variant="primary" :disable="loading">
                        Salvar
                    </b-button>
                </b-form>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                name: null,
                email: null,
                password: null,
                phone: null,
            }
        }
    },
    created() {
        this.$root.$on('createTeacher', () => {
            this.$bvModal.show('createTeacher')
        });
    },
    methods: {

        submit() {
            this.loading = true;
            axios.post('/teacher/teachers/create', {
                ...this.form,
            })
                .then((result) => {

                    // Callback
                    this.$emit('created')

                    // Close Modal
                    this.$bvModal.hide('createTeacher')

                    // Message
                    this.$toast.success('Professor adicionado com sucesso !')

                    // Clear Form
                    this.form = {
                        name: null,
                        email: null,
                        password: null,
                        phone: null,
                    }

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {

                    // Check Errors
                    this.errors = this.setErrors(errors)

                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
